import React, { useCallback, useState } from 'react';
import { Popup } from 'devextreme-react/popup';
import { Button } from 'devextreme-react/button';
import { formatMessage } from 'devextreme/localization';
import style from './popuperrormvp.module.scss';

const PopupErrorMVP = ({
  children,
  visible,
  message,
  techInfo,
  width,
  onHiding,
  types,
  title,
  pre = false,
  shading = true,
  position = 'center',
  // Закрытие попапа при нажатии вне элемента
  closeOnOutsideClick = true
}) => {
  const [visibleTechInfo, setVisibleTechInfo] = useState(false);

  const onClickPodrob = useCallback(() => {
    setVisibleTechInfo(true);
  }, [setVisibleTechInfo]);

  const renderTemplate = useCallback(() => (
    <div className={style.header}>
      <div className={style.title}>
        <Button icon="info"
                stylingMode="text"
                activeStateEnabled={false}
                disabled
        />
        <span>{title || formatMessage('textError').warning}</span>
      </div>
      <Button elementAttr={{ class: style.button_close }}
              icon="close"
              stylingMode="text"
              onClick={() => {
                onHiding();
                setVisibleTechInfo(false);
              }}
      />
    </div>
  ), [onHiding, title]);

  return (
    <Popup className={style.popup + types}
           dragEnabled
           resizeEnabled
           restorePosition
           closeOnOutsideClick={closeOnOutsideClick}
           showTitle
           height="auto"
           width={width || 'auto'}
           visible={visible}
           title={title || formatMessage('textError').warning}
           titleRender={renderTemplate}
           onHiding={() => {
             onHiding();
             setVisibleTechInfo(false);
           }}
           shading={shading}
           position={position}
    >
      <div style={{ whiteSpace: (pre ? 'pre' : 'normal') }}>
        {message}
      </div>
      <div style={{ display: (visibleTechInfo ? 'block' : 'none') }}>
        {techInfo}
      </div>
      <div className={style.podrob}
           style={{ display: ((!visibleTechInfo && techInfo && techInfo !== '' && message) && message?.trim() !== techInfo?.trim() ? 'block' : 'none') }}>
        <Button icon="chevrondown"
                text={formatMessage('textError').detail}
                stylingMode="text"
                onClick={onClickPodrob}
        />
      </div>
      {children}
    </Popup>
  );
};

export default React.memo(PopupErrorMVP);
